import { openPopup } from './popups'

//let globalHash = window.location.hash
let toHash = $('.js-go-to')

// go to hash moved to preloader
//if (globalHash) goToHash(globalHash)

toHash.click(function (e) {
  e.preventDefault()
  let goTo = '#' + $(this).data('go-to')
  goToHash(goTo)
})

$('a').click(function(e){
  let url = $(this).attr('href')
  if (url.charAt(0) === '#'){
    e.preventDefault()
    goToHash(url)
    return false
  }
})



//-- Set active menu el
// let navigationBlocks = $('.js-nav-block')
// $(window).bind('scroll', function () {
//   let currentTop = $(window).scrollTop()
//   let currentEl = ''
//   navigationBlocks.each(function (index) {
//     if ($(this).attr('id').length) {
//       let elemTop = $(this).offset().top - 100
//       if (currentTop >= elemTop) currentEl = $(this)
//     }
//   })
//   setActiveElement(currentEl)
//
// })


// let lastActive = ''
// function setActiveElement(el){
//   let id = $(el).attr('id')
//   if (lastActive !== id) {
//     lastActive = id
//     let navElem = $('[data-go-to="' + id + '"]')
//
//     if (!el) id = ''
//     toHash.removeClass('js-active')
//     navElem.addClass('js-active')
//     setUrlHash(id)
//   }
// }


export function goToHash (hash) {
  if (hash) {
    hash = hash.replace('#', '')
    hash = hash.replace('/', '')
    let hashEl = ''
    let isPopup = 0

    if (hash.search('popup-') !== -1){
      if (hash !== 'popup-video-popup') {
        hashEl = hash.replace('popup-', '')
        isPopup = 1
      }
    } else {
      hashEl = $('#' + hash)
    }

    if (hashEl.length) {
      if (isPopup){
        openPopup(hashEl)
      } else {
        $('html, body').animate({ scrollTop: hashEl.offset().top - 100 })
      }
    }
    lastHistory = ''
    setUrlHash(hash)
  }
}



let lastHistory = '';
let hashTimeout = 0;
export function setUrlHash (hash) {
  if (lastHistory !== hash && !hashTimeout && window.location.hash !== '#'+hash) {
    lastHistory = hash
    if (window.history && window.history.pushState) {
      let curUrl = window.location.href.split(/[?#]/)[0]
      if (hash) hash = '#' + hash
      history.pushState({}, null, curUrl + hash)
      hashTimeout = 1
      setTimeout(function(){hashTimeout = 0}, 300)
    }
  }
}
